"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminatePolicyRequestDtoTerminationReasonEnum = void 0;
exports.TerminatePolicyRequestDtoTerminationReasonEnum = {
    TerminationAtRenewal: 'termination_at_renewal',
    TerminationAfterClaim: 'termination_after_claim',
    TerminationDueToUnderwriting: 'termination_due_to_underwriting',
    TerminationDueToDefaultOfInitialPremium: 'termination_due_to_default_of_initial_premium',
    TerminationDueToDefaultOfSubsequentPremium: 'termination_due_to_default_of_subsequent_premium',
    TerminationDueToDoubleInsurance: 'termination_due_to_double_insurance',
    TerminationDueToLossOfRisk: 'termination_due_to_loss_of_risk',
    TerminationDueToBreachOfDuty: 'termination_due_to_breach_of_duty',
    TerminationDueToExpiry: 'termination_due_to_expiry',
    Withdrawal: 'withdrawal',
    Other: 'other'
};
